export default {
  props: {
    context: {
      type: Object,
    },
  },

  components: {},

  mounted() {},

  data() {
    return {
      selected: [],
      dir: window.location.hostname === 'localhost' ? '../../assets/images' : '/modules/custom/kiw_form/assets/images',
    };
  },

  computed: {
    options: {
      get() {
        return this.context.attrs.options;
      },
    },
  },

  methods: {},

  watch: {
    selected(val) {
      this.context.node.input(val);
    },
  },
};
